import React from 'react';
import { useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import SelectField from '../../common/components/SelectField';
import clientSelector from '../../clients/clientSelector';
import createClientStatistics from './createStatistics';
import statistics from '../../common/helpers/statistics';
import type { Statistic } from '../../common/types/statistics/dndStatistics';
import type { StatisticsFilter as StatisticsFilterType } from '../../common/types/statistics/statistics';

type Props = {
  filterStartYear: number;
  setStatistic: (statistic: Statistic) => void;
};

function StatisticsFilter({ filterStartYear, setStatistic }: Props) {
  const clients = useSelector(clientSelector.getClients);

  const currentYear = new Date().getFullYear();
  const yearDifference = currentYear - filterStartYear >= 0 ? currentYear - filterStartYear : 0;

  const years = new Array(yearDifference + 1).fill(0).map((_, index) => {
    const year = currentYear - index;
    return { label: `${year}`, value: `${year}` };
  });

  const [statisticFilter, setStatisticFilter] = React.useState<StatisticsFilterType>(statistics.defaultFilter);

  return (
    <Paper
      variant='outlined'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        margin: '24px 0 48px 0',
        padding: '20px 24px',
        minWidth: '300px',
        maxWidth: '650px',
        backgroundColor: '#FAFAFA',
      }}
    >
      <Typography fontSize='1.2rem' mb={2}>
        Filter
      </Typography>
      <Grid container rowSpacing={2} columnSpacing={4}>
        <Grid item xs={6}>
          <SelectField
            label='Jahr'
            options={years}
            value={statisticFilter.year}
            fullWidth
            handleChange={(value) => {
              if (typeof value === 'string') {
                setStatisticFilter({ ...statisticFilter, year: value });
              }
            }}
          />
        </Grid>
      </Grid>
      <Button
        variant='contained'
        onClick={() => {
          if (clients != null) {
            const statistic = createClientStatistics(clients, statisticFilter);
            setStatistic(statistic);
          }
        }}
        sx={{ marginTop: '16px', marginLeft: 'auto' }}
      >
        Statistik anzeigen
      </Button>
    </Paper>
  );
}

export default StatisticsFilter;
